import { BackIcon, CloseNotBorderIcon } from "Components/icons/Icons";

export default function ModalCloseButton({
    className = "",
    onClose,
    id,
    onlyIsCloseIcon = false,
    isCloseNotBorder = false,
    notIsModal = false
}) {
    const CloseIcon = isCloseNotBorder ? (
        <CloseNotBorderIcon className="tw-block" />
    ) : (
        <img
            className="tw-block"
            src="/assets/images/close-Icon2.svg"
            alt="X"
        />
    );

    const baseClasses =
        `tw-flex tw-justify-center tw-items-center tw-h-[35px] tw-w-[35px] tw-rounded-full
        tw-absolute tw-top-[15px] tw-left-[15px] sm:tw-left-auto sm:tw-right-[15px]
        hover:tw-bg-[#f5f5f5] hover:tw-cursor-pointer
        `;

    return (
        <div
            className={`${baseClasses} ${className}`}
            data-bs-dismiss={notIsModal ? null : "modal"}
            aria-label="Close"
            id={id || "modal-close"}
            onClick={onClose}
        >
            {onlyIsCloseIcon ? (
                CloseIcon
            ) : (
                <>
                    {/* Mobile: Back Icon */}
                    <BackIcon className="tw-block sm:tw-hidden" />

                    {/* Desktop: Close Icon */}
                    <span className="tw-hidden sm:tw-block">{CloseIcon}</span>
                </>
            )}
        </div>
    );
}
